import React from 'react';
import { useSearchParams, useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';
import LocalStorageService from '../../services/localStorage';
import {
    Box,
} from '@mui/material';

import SearchForm from './SearchForm';
import SearchResult from './SearchResult';

const localStorageService = LocalStorageService.getService();

const PolicySearch = () => {
    const { orgId } = useParams(); // Getting the segment from the route
    const [searchParams] = useSearchParams();

    const getParamCaseInsensitive = (params, keyToFind) => {
        for (const [key, value] of params.entries()) {
            if (key.toLowerCase() === keyToFind.toLowerCase()) {
                return value;
            }
        }
        return null;
    };
    

    const lob = getParamCaseInsensitive(searchParams, "lob");
    const procedure_code = getParamCaseInsensitive(searchParams, "procedure_code");
    const service_date = getParamCaseInsensitive(searchParams, "service_date");
    const keyword = getParamCaseInsensitive(searchParams, "keyword");
    const policy_type = getParamCaseInsensitive(searchParams, "policy_type");
    const policy_shortname = getParamCaseInsensitive(searchParams, "policy_shortname");
    const status = getParamCaseInsensitive(searchParams, "status");


    const urlParams = {
        lob: lob,
        procedure_code: procedure_code,
        service_date: service_date,
        keyword: keyword,
        policy_type: policy_type,
        policy_shortname:policy_shortname,
        status: status ? status.split(',') : [],
    };


    const [formSubmitted, setFormSubmitted] = React.useState(false);
    const [searchResult, setSearchResult] = React.useState([]);
    const [showLOB, setShowLOB] = React.useState(true);
    const instructionsRef = React.useRef();

    
    const brandingInfo = localStorageService.getBrandingInfo();

    React.useEffect(() => {

        if (brandingInfo) {
           // instructionsRef.current.innerHTML = JSON.parse(brandingInfo).instructions;
        }

    }, [instructionsRef, brandingInfo]);

    return (
        <Box component="section" className="headerBox">
            <Grid container className="container">
                <Grid item size={12}>
                    {/*<div ref={instructionsRef}></div>*/}

                    <SearchForm setShowLOB={setShowLOB} showLOB={showLOB} setFormSubmitted={setFormSubmitted} orgId={orgId} urlParams={urlParams} setSearchResult={setSearchResult} />

                    {formSubmitted && (<><hr style={{borderTop:'3px solid #ccc', margin: '20px 0'}} />
                    <SearchResult lob={lob} showLOB={showLOB} searchResult={searchResult} orgId={orgId} /></>)}
                </Grid>
            </Grid>
        </Box>
    )
}

export default PolicySearch;